import {
    Box, Icon, Modal, ModalContent, ModalOverlay, useDisclosure, ModalHeader, ModalCloseButton, ModalBody, Text, Button, Center, ModalFooter
} from '@chakra-ui/react'
import React from 'react'
import { FiHelpCircle, FiChevronUp, FiChevronDown } from 'react-icons/fi';

export const JobInfoHelpButton = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <Box >
            <Box onClick={onOpen} borderRadius="0.5em" cursor="pointer" fontSize="0.8em" color="white" display="inline" padding="1" bg="green.500">
                Help <Icon as={FiHelpCircle} />
            </Box>
            <Modal isOpen={isOpen} onClose={onClose} >
                <ModalOverlay />
                <ModalContent mr="2" ml="2" maxH="80vh" overflow="scroll"
                    css={{
                        '&::-webkit-scrollbar': {
                            width: '4px',
                        },
                        '&::-webkit-scrollbar-track': {
                            width: '6px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            borderRadius: '24px',
                        },
                    }}
                >
                    <ModalHeader>Let's Create a <Text display="inline" fontWeight="bold" color="green.600">Checklist!</Text></ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>Checklist lets you and your employee track progress of tasks to be done. To create a checklist, follow the steps below.<br /><br /></Text>
                        <Text fontWeight="bold">Step 1:</Text>
                        Add checklist using the add button <br />
                        <Button mt="2" borderRadius="0.5em" borderStyle="dashed" borderWidth="3px" borderColor="gray.400" display="flex" cursor="pointer" color="gray.500" paddingLeft="4">
                            <Center><Box borderWidth="3px" w="4" h="4" borderRadius="0.25em" marginRight="1" ></Box></Center> Add a new task
                        </Button>
                        <br />
                        <Text fontWeight="bold">Step 2:</Text>
                        Assign the task to an employee or make it available to every employee. Each employee would only be able to view tasks that were assigned to them unless it was assigned to everyone.
                        <br />
                        <br />
                        <Text fontWeight="bold">Step 3:</Text>
                        Your checklist item will be created and you can view the example checklist in the mobile view. <br /><br />

                        <Box borderRadius="0.5em" p="1" borderWidth="3px" borderColor="blue.800" maxW="80px" h="150px" m="auto" >
                            <Box borderRadius="0.2em" bg="gray.200" height="10px" mt="8px" marginX="2px">
                            </Box>
                            <Box borderRadius="0.2em" bg="gray.200" height="10px" mt="4px" marginX="2px">
                            </Box>
                            <Box borderRadius="0.2em" bg="gray.200" height="10px" mt="4px" marginX="2px">
                            </Box>
                            <Box borderRadius="0.2em" bg="gray.200" height="10px" mt="4px" marginX="2px" width="50px">
                            </Box>


                        </Box>

                        <br />
                        Your employees will access this checklist from their dashboard on their mobile phone browser. The checklist is accesible on any mobile device (android/IOS) and they can upload photos and check through the job's tasks.<br /><br />

                        Visualise how your employee would view the checklist on their mobile phone. The checklist autosaves as you make edits. <br /><br />
                        <Text fontSize="0.8em"><b>Tips:</b> Provide description/details that would not crowd the mobile phone space available to your employees. If required, you can always break down large task into bite size tasks.</Text>
                        <br /><br />
                        <Text fontWeight="bold">Final steps:</Text>
                        Reorder your checklist by dragging and dropping or clicking "Move Up" or "Move Down" <br />
                        <Box width="100%" mt="2">
                            <Icon as={FiChevronUp} color="green.500" mr="1" mb="1" /> Move Up
                        </Box>
                        <Box width="100%" mt="2">
                            <Icon as={FiChevronDown} color="green.500" mr="1" mb="1" /> Move Down
                        </Box>
                        <br />
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" mr={3} bg="green.600" onClick={onClose}>
                            I'm Ready!                            </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

        </Box >
    )
}

